<template>
  <div class="RequestManagementSearchPanel">
    <box class="" :title="this.$t('search')">
      <div class="px-3 pt-2">
        <v-row>
          <v-col>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <label for="period">{{ $t("period") }}: </label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="period"
                          :items="periodList"
                          :label="$t('period')"
                          item-text="Name"
                          item-value="Code"
                          return-object
                          dense
                          solo
                          v-on:change="changePeriod"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label for="sectionType">{{ $t("sectionType") }}: </label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="sectionType"
                          :items="sectionTypes"
                          :label="$t('sectionType')"
                          item-text="Name"
                          item-value="Code"
                          return-object
                          dense
                          solo
                          v-on:change="changeSectionType"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label for="requestType">{{ $t("requestType") }}:</label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="requestType"
                          :items="requestTypes"
                          :label="$t('requestType')"
                          item-text="Name"
                          item-value="Code"
                          return-object
                          dense
                          solo
                          v-on:change="changeRequestType"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>
          <v-col>
            <div>
              <v-checkbox
                dense
                class="management-checkbox"
                v-model="onlyCanApprove"
                :label="$t('onlyCanApprove')"
              ></v-checkbox>
            </div>
            <div>
              <v-checkbox
                dense
                class="management-checkbox"
                v-model="editedByMe"
                :label="$t('editedByMe')"
              ></v-checkbox>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="search">{{ $t("search") }}</v-btn>
        </v-card-actions>
      </div>
    </box>
  </div>
</template>

<script>
import PeriodList from "../../model/PeriodList";
import type from "../../model/RequestManagementType";
import ResultType from "../../model/ResultType";
export default {
  props: {
    accessTo: Number,
  },
  components: {},
  data() {
    return {
      requestTypes: [],
      requestType: "",
      initBeginDate: null,
      beginDate: "",
      initEndDate: null,
      endDate: "",
      sectionType: "",
      sectionTypes: [],
      onlyCanApprove: true,
      editedByMe: false,
      periodList: [],
      period: "",
    };
  },
  mounted() {
    this.requestTypes = type.RequestTypeArray();
    if (this.requestTypes.length > 0) {
      this.requestType = this.requestTypes[0];
    }

    this.periodList = PeriodList.getArray();
    if (this.periodList.length > 0) {
      this.period = this.periodList[0];
    }


    this.getSectionTypes();
    this.search()
  },

  methods: {
    getSectionTypes() {
      //this.sectionTypes.push({ Name: this.$t("allSection"), Code: -1 });
      //this.sectionType = this.sectionTypes[0];

      var params = new URLSearchParams();
      params.append("accessTo", this.accessTo);

      this.$store.dispatch("sections/GetSectionsList", { params }).then((result) => {
        //console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          this.sectionType = this.sectionTypes[0];
        }
      });
    },
    changeRequestType() {},
    changeSectionType() {},
    changePeriod() {},
    async GetPeriodBeginAndEndDate(year, period) {
      const params = new URLSearchParams();
      params.append("periodNumber", period);
      params.append("year", year);

      var res = await this.$store
        .dispatch("GetPeriodBeginAndEndDate", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            if (result.data.length > 0) {
              let data = result.data[0];
              //this.GetPersonDayWorks(data.BeginDate, data.EndDate);
              return data;
            } else {
              return null;
            }
          }
        });
      return res;
    },
    async search() {
      /*if (ddlPeriods.SelectedValue != "0") {
        var periodDate = EosDbConnection.GetBeginAndEndOfPeriod(
          ddlPeriods.SelectedValue
        );
        if (
          ddlPeriods.SelectedValue == "1" &&
          periodDate[0].Substring(0, 4) == "12"
        ) {
          EspecificExtraWork.BeginDateP = year - 1 + "/" + periodDate[0];
          EspecificExtraWork.EndDateP = year + "/" + periodDate[1];
        } else {
          EspecificExtraWork.BeginDateP = year + "/" + periodDate[0];
          EspecificExtraWork.EndDateP = year + "/" + periodDate[1];
        }
      } else {
        EspecificExtraWork.BeginDateP = year + "/01/01";
        EspecificExtraWork.EndDateP = year + "/12/30";
      }*/
      var moment = require("jalali-moment");
      var year = moment().locale("fa").format("YYYY");
      if (this.period.Code.toString() != "0") {
        var result = await this.GetPeriodBeginAndEndDate(
          year,
          this.period.Code
        );
        //console.log(result);
        this.beginDate = result.BeginDate;
        this.endDate = result.EndDate;
      } else {
        this.beginDate = year + "/01/01";
        this.endDate = year + "/12/30";
      }

      /*var section = "";
      if (this.sectionType?.Code?.toString().trim() == "-1") {
        section = "";
      } else {
        section = this.sectionType?.Code?.toString().trim() || "";
      }*/

      var searchParams = {
        beginDate: this.beginDate,
        endDate: this.endDate,
        searchKind: this.requestType.Code,
        status: this.requestType.Code,
        section: this.sectionType?.Code?.toString().trim() || "-1",
        editedByMe: this.editedByMe,
        onlyCanApprove: this.onlyCanApprove,
      };

      this.$emit("search", searchParams);
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
}

::v-deep .management-checkbox .v-label {
  font-size: 0.9rem;
  text-align: right;
}
</style>